import { Link } from "react-router-dom";
import {
  heroFloatingCards,
  pharmacyAiLinks,
} from "views/components/pages/PharmacyAI/constants";
import { PageContainer } from "views/components/pages/PharmacyAI/layout";
import {
  FloatingCard,
  HeroActions,
  HeroCopy,
  HeroGradient,
  HeroGrid,
  HeroSection,
  HeroVisual,
} from "./styles";

const Hero = () => {
  return (
    <HeroSection>
      <PageContainer>
        <HeroGrid>
        <HeroCopy>
          <h1>Workflow Automation for Pharmacy</h1>
          <p>
            Automate manual work in community pharmacy using our AI-powered
            solutions. Designed to maximise efficiency, improve productivity
            and drive revenue growth.
          </p>
          <HeroActions>
            <a
              className="btn-primary-dark"
              href={pharmacyAiLinks.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
            >
              Speak to a Human
            </a>
            <Link className="btn-outline" to={pharmacyAiLinks.contact}>
              Contact Us
            </Link>
          </HeroActions>
        </HeroCopy>

        <HeroVisual>
          <HeroGradient />
          {heroFloatingCards.map((card) => (
            <FloatingCard
              key={card.id}
              $variant={card.variant}
              $top={card.position.top}
              $right={card.position.right}
              $bottom={card.position.bottom}
              $left={card.position.left}
            >
              {card.stat ? (
                <>
                  <div className="stat">{card.stat}</div>
                  <p>{card.description}</p>
                </>
              ) : (
                <>
                  <h3>{card.title}</h3>
                  <p>{card.description}</p>
                </>
              )}
            </FloatingCard>
          ))}
        </HeroVisual>
        </HeroGrid>
      </PageContainer>
    </HeroSection>
  );
};

export default Hero;
